import classnames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var Toggle = function Toggle(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    notInteractive = _ref.notInteractive,
    on = _ref.on,
    onClick = _ref.onClick;
  var classes = classnames('ptr-Toggle', {
    'is-disabled': disabled,
    'is-on': on,
    'is-interactive': !notInteractive
  }, className);
  return /*#__PURE__*/_jsx("div", {
    onClick: onClick,
    className: classes,
    tabIndex: disabled || notInteractive ? -1 : 0,
    children: /*#__PURE__*/_jsx("div", {
      className: "ptr-Toggle-bullet"
    })
  });
};
Toggle.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  notInteractive: PropTypes.bool,
  on: PropTypes.bool,
  onClick: PropTypes.func
};
export default Toggle;